import equipmentUtils from '@/pages/Equipment/equipment.utils'
import timeUtils from '@/utils/time.utils'
import useEquipment from '@/pages/Equipment/hooks/useEquipment'
import css from './completedMaintenanceEventItem.module.css'
import { IEquipmentMaintenanceBlank } from '@/pages/Equipment/equipment.types'
import Tag from '@/shared/Tags/Tag'
import Button from '@/shared/Buttons/Button'
import { useNavigate } from 'react-router-dom'
import urls from '@/navigation/urls'
import cn from '@/utils/cn'
import { useRef } from 'react'

interface IProps {
  maintenanceBlank: IEquipmentMaintenanceBlank
}

const CompletedMaintenanceEventItem = (props: IProps) => {
  const navigate = useNavigate()
  const equipment = useEquipment(props.maintenanceBlank.equipmentId)
  const commentRef = useRef<HTMLParagraphElement>()

  const renderTag = () => {
    const text = props.maintenanceBlank.type === 'PLANNED' ? 'Плановое' : 'Внеплановое'
    const color = props.maintenanceBlank.type === 'PLANNED' ? 'gray' : 'red'
    return (
      <Tag color={color} style={{ height: 'fit-content' }}>
        <p className="text-caption" style={{ color: 'inherit' }}>
          {text}
        </p>
      </Tag>
    )
  }

  const changeCommentWrap = () => {
    const tempValue = commentRef.current.dataset.wrap
    commentRef.current.dataset.wrap = tempValue === 'wrap' ? 'unwrap' : 'wrap'
  }

  if (!equipment) return null

  return (
    <div className={css.wrapper}>
      <div className="flex-lines gap4">
        {renderTag()}
        <span className="text-nm line-clamp text-pre" style={{ textAlign: 'left', flexShrink: 0 }}>
          {equipmentUtils.getEquipmentAddress(equipment.location, {
            includeLocationDescription: true,
            includeCountry: false,
          })}
        </span>
        <div className="text-sm text-secondary-strong line-clamp text-pre">
          {timeUtils.formatDate(props.maintenanceBlank.createdAt, 'dd.MM.yyyy, HH:mm:ss')}
        </div>
      </div>
      <div className="flex-lines gap12 mt8">
        {props.maintenanceBlank.comment && (
          <div className={css.commentBlock}>
            <p className="text-secondary-strong text-sm">Комментарий:</p>
            <p
              ref={commentRef}
              data-wrap="wrap"
              onClick={changeCommentWrap}
              className={cn('text-nm', css.ellipsisLines)}
            >
              {props.maintenanceBlank.comment}
            </p>
          </div>
        )}
        <Button
          size="default"
          type="default"
          text="Показать в Журнале ТО"
          className="mt8 12"
          onClick={() =>
            navigate(urls.liftPageMaintenanceViewBlank(props.maintenanceBlank.equipmentId, props.maintenanceBlank.id))
          }
        />
      </div>
    </div>
  )
}

export default CompletedMaintenanceEventItem
